<div class="general-container flex flex-col" [ngClass]="{'justify-center': step === 4, 'justify-between': step !== 4}">
    <!--<img class="info-BTN" src="../../../../assets/images/invest/info.svg" alt="info" (click)="openHelp('first', 0)">-->
    <div class="header-container">
        <!-- <div *ngIf="step > 0 && step < 4 && !isTimeStop" class="mobile-header" (click)="showInfo()">
            <div [ngClass]="{'project': step === 2 || step === 3}">
                <h3 class="font-sans text-eggplant-100 text-xl">{{ headerData.name }}</h3>
                <p class="font-sans text-gray-25 text-h400">{{ 'invest.Header.Miss' | translate }} {{ headerData.objective - headerData.contributed | localeNumber }} €</p>
                <img *ngIf="step === 1" src="../../../../assets/images/invest/down.svg" alt="arrow down">
            </div>
        </div> -->
        <div *ngIf="step > 0 && step < 4 && !isTimeStop && !loaderInvestProcess" class="desktop-header">
            <div class="flex place-content-between items-center gap-32 md:max-w-[1200px] mx-auto pb-20">
                <div class="project-name cell">
                    <p class="font-sans text-eggplant-100 text-xl">{{ headerData.name }}</p>
                </div>

                <div *ngIf="step === 1" class="flex border border-eggplant-100/[0.1] rounded-2xl pb-[8px] px-[16px]">
                    <div class="pr-24 border-r border-r-eggplant-100/[0.1] mt-[8px]">
                        <h4 class="font-sans text-m text-eggplant-100/[0.25]">{{ 'invest.Header.Estimated' | translate
                            }}</h4>
                        <p class="font-sans text-eggplant-100 text-xl">{{ headerData.profitability | localePercentNumber
                            }}% {{ 'invest.Header.Annual' | translate }}</p>
                    </div>
                    <div class="px-24 border-r border-r-eggplant-100/[0.1] mt-[8px]">
                        <h4 class="font-sans text-m text-eggplant-100/[0.25]">{{ 'invest.Header.deadline' | translate }}
                        </h4>
                        <p class="font-sans text-eggplant-100 text-xl">{{ headerData.term | number:'1.0-0':'es' }} {{
                            'invest.Header.years' | translate }}</p>
                    </div>
                    <div class="pl-24">
                        <div class="graphic-container cell">
                            <!-- Caso normal: falta por invertir -->
                            <p class="font-sans text-gray-25 text-h400 text-right"
                                *ngIf="headerData.status !== 15 && (headerData.objective - headerData.contributed) >= 0">
                                {{
                                'invest.Header.Miss' | translate }}
                                <span *ngIf="!totalOfficialPercent">{{ headerData.objective - headerData.contributed |
                                    localeNumber }}
                                    €</span>
                                <span
                                    *ngIf="totalOfficialPercent && (headerData.contributed <= headerData.objective_official)">{{
                                    headerData.objective_official - headerData.contributed |
                                    localeNumber }} €</span>
                                <span
                                    *ngIf="totalOfficialPercent && (headerData.contributed > headerData.objective_official)">{{
                                    headerData.objective - headerData.contributed | localeNumber }}
                                    €</span>
                            </p>
                            <!-- Caso 100%+: por formalizar (sin contar reserved) -->
                            <p class="font-sans text-gray-25 text-h400 text-right"
                                *ngIf="headerData.status !== 15 && (headerData.objective - headerData.contributed) < 0">
                                {{ 'INVEST.NOT_FORMALIZED' | translate }}
                                <span>{{ headerData.objective - (headerData.contributed - headerData.reserved) |
                                    localeNumber }}
                                    €</span>
                            </p>
                            <p class="font-sans text-gray-25 text-h400 text-right" *ngIf="headerData.status === 15">{{
                                'invest.Header.finish_in' | translate }}
                                <span>{{ daysLeft | number:'1.0-0':'es' }} {{ 'invest.Header.days' | translate }}</span>
                            </p>
                            <fun-overview-bar [data]="barData" [hiddePercent]="true" [hiddeObjetive]="true"
                                [hiddeLegend]="true" [size]="'s'"></fun-overview-bar>
                            <p *ngIf="!totalOfficialPercent"
                                class="font-sans text-eggplant-100/[0.25] text-m text-right">{{ 'invest.Popup.objective'
                                |
                                translate }} {{ headerData.objective | localeNumber }} €</p>
                            <p *ngIf="totalOfficialPercent && (headerData.contributed <= headerData.objective_official)"
                                class="font-sans text-eggplant-100/[0.25] text-m text-right">{{ 'invest.Popup.objective'
                                |
                                translate }} {{ headerData.objective_official | localeNumber }} €</p>
                            <p *ngIf="totalOfficialPercent && (headerData.contributed > headerData.objective_official)"
                                class="font-sans text-eggplant-100/[0.25] text-m text-right">{{ 'invest.Popup.objective'
                                |
                                translate }} {{ headerData.objective | localeNumber }} €</p>
                        </div>
                    </div>
                </div>
                <div *ngIf="step === 1">
                    <img class="w-[172px] h-[90px] rounded-2xl" [src]="headerData.projectImg" alt="imagen del proyecto">
                </div>
                <div *ngIf="step === 2 || step === 3" class="cell flex">
                    <p class="font-sans text-white text-m num-step bg-eggplant-100/[0.25]">1</p>
                    <p class="font-sans text-eggplant-100/[0.25] text-m">{{ 'INVEST.INVESTMENT' | translate }}: {{
                        invest |
                        localeNumber }} €</p>
                </div>
                <div *ngIf="(step === 2 || step === 3) && investByCard" class="cell flex">
                    <p class="font-sans text-white text-m num-step"
                        [ngClass]="{'bg-eggplant-100/[0.25]': step === 3, 'linear-gradient-2': step === 2 }">2</p>
                    <p class="font-sans text-m"
                        [ngClass]="{'text-eggplant-100/[0.25]': step === 3, 'bg-gradient-3-text': step === 2 }">{{
                        'INVEST.PAY' | translate }}</p>
                </div>
                <div *ngIf="step === 2 || step === 3" class="cell flex">
                    <p class="font-sans text-white text-m num-step"
                        [ngClass]="{'bg-eggplant-100/[0.25]': step === 2 && investByCard, 'linear-gradient-2': step === 3  || (step === 2 && !investByCard) }">
                        {{ investByCard ? '3' : '2' }}</p>
                    <p class="font-sans text-m"
                        [ngClass]="{'text-eggplant-100/[0.25]': step === 2, 'bg-gradient-3-text': step === 3 || (step === 2 && !investByCard)}">
                        {{ 'INVEST.DOCUMENTATION_AND_SIGN' | translate }}</p>
                </div>
                <div *ngIf="step === 2 || step === 3" class="cell flex">
                    <p class="font-sans text-white text-m num-step bg-eggplant-100/[0.25]">
                        <span *ngIf="!investByCard">3</span>
                        <span *ngIf="investByCard">4</span>
                    </p>
                    <p class="font-sans text-eggplant-100/[0.25] text-m">{{ 'AUTOINVEST.HEADER.TITLE_5' | translate }}
                    </p>
                </div>
            </div>
        </div>
    </div>
    <app-invest-test-convenience (emitSuccess)="testSucess($event)" (testFail)="testFail()" [testInfo]="testInfo"
        [profile]="profile" *ngIf="step === 0"></app-invest-test-convenience>
    <app-invest-reservation *ngIf="step === 1 && !loaderInvestProcess && headerData.status === 15" [amount]="amount"
        [data]="bodyData" [modelData]="data.investInfo" (eventCloseModalCard)="closeModal()"
        (deleteHeaderEvent)="deleteHeader($event)"
        (reserveHubspotEvent)="updateHubsportReservation($event)"></app-invest-reservation>
    <app-invest-body *ngIf="step === 1 && !loaderInvestProcess && headerData.status !== 15"
        (moneyToInvest)="getMoneyToInvest($event)" (amountValue)="getAmountValue($event)" (openTestEvent)="showTest()"
        (setPayType)="getPayType($event)" (setCodePromotion)="getCodePromotion($event)"
        (localInvestIdEvent)="getLocalInvestId($event)" (addPromotionalMoneyEvent)="getPromotionalMoney($event)"
        (closeAndCheckIbanEvent)="closeAndCheckIban()" (hasToBookInvestmentEvent)="getHasToBookInvestment($event)"
        (userValidatedInPriorityGroupEvent)="getUserValidatedInPriorityGroup($event)" [data]="bodyData"
        [errors]="errors" [amount]="amount" [localInvestProject]="localInvestProject"
        [profile]="profile"></app-invest-body>
    <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 -mt-[60px]"
        *ngIf="step === 1 && loaderInvestProcess">
        <fun-spinner *ngIf="step === 1 && loaderInvestProcess"></fun-spinner>
    </div>
    <div class="ifr-container"
        *ngIf="((step === 3 && investByCard) || (step === 2 && !investByCard)) && !previewDocuments">
        <app-invest-ifr style="height: 100%;" [transaction]="transaction" [ifr]="1" [projectData]="data"
            (signErrorEvent)="signError()" (startSignEvent)="startSign($event);"
            (signaturitIssueEvent)="signaturitIssue()" (editInvestEvent)="editInvest()"
            (goToPreviewDocumentsEvent)="goToSignDocuments()" (lleidanetSignOkEvent)="lleidanetSignOk()"
            (eventCloseModalCard)="closeModal()"></app-invest-ifr>
    </div>
    <div class="ifr-container" *ngIf="step === 2 && investByCard">
        <app-invest-mangopay [investData]="transaction" [mpWalletModel]="data.investInfo.wallet"
            (editInvestEvent)="editInvest()" (eventStopTime)="stopTime()" (successInvested)="successInvestedCard()"
            (successInvestedHasToSignEvent)="finishInvest()"></app-invest-mangopay>
    </div>
    <div class="preview-container"
        *ngIf="((step === 3 && investByCard) || (step === 2 && !investByCard)) && previewDocuments">
        <app-invest-document-viewfinder (prevEvent)="editInvest()" (goToSignDocuments)="goToSignDocuments()"
            [documents]="data.signDocuments" [hasBackBtn]="!investByCard"></app-invest-document-viewfinder>
    </div>
    <app-invest-success *ngIf="step === 4" (eventShare)="share()" (eventGoHome)="goHome()"
        (closeModalEvent)="newInvest()" [refCode]="data.investInfo.refCode" [amount]="invest" [name]="headerData.name"
        [prevInvest]="headerData.invested" [data]="data" [priorityGroupNumber]="priorityNumber"></app-invest-success>
    <div *ngIf="step === 5" class="flex justify-center items-center h-full overflow-auto">
        <fun-overal-message [text]="bookText" [image]="2" [btnList]="btnBookList"
            (btnEvent)="bookInvestmentAction($event)"></fun-overal-message>
    </div>
    <!-- Priority group warning / reservation view -->
    <div *ngIf="step === 6" class="flex justify-center items-center h-full overflow-auto px-24 py-32">
        <div class="flex flex-col items-center max-w-[720px] text-center gap-24">
            <!-- Vista de mensaje de, cuidado que quieres reservar pero vas al 100% -->
            <ng-container *ngIf="hasToBookInvestment && percentInv > 100">
                <fun-icon [name]="'info-circle'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
                <h2 class="font-sans text-h600 md:text-h700 bg-gradient-2-text linear-gradient-2">{{
                    'INVEST.PROJECT_100' | translate }}</h2>
                <p class="font-sans text-gray-40 text-l">Entre inversiones y reservas, este
                    proyecto supera el 100% de su objetivo de financiación, por lo que es posible que tu reserva se
                    quede fuera.</p>
                <fun-new-button size="l" [buttonType]="'colorFull'" title="Entendido"
                    (eventClick)="continueFromOverfundedWarning()"
                    [classExtra]="'!w-full max-w-[300px]'"></fun-new-button>
            </ng-container>

            <!-- Vista de reservas: usuario sin grupo prioritario disponible -->
            <ng-container *ngIf="shouldShowReservation">
                <fun-icon [name]="'calendar'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
                <h2 class="font-sans text-h600 md:text-h700 bg-gradient-2-text linear-gradient-2">
                    {{ 'INVEST.GROUP_100' | translate }}</h2>
                <p class="font-sans text-gray-40 text-l">{{ 'INVEST.GROUP_100_TEXT' | translate }}</p>
                <fun-new-button size="l" [buttonType]="'colorFull'" title="Reservar mi inversión"
                    (eventClick)="continueFromOverfundedWarning()"
                    [classExtra]="'!w-full max-w-[300px]'"></fun-new-button>
            </ng-container>

            <!-- Vista con tabla de grupos: usuario con grupo SIN investObjective -->
            <ng-container *ngIf="!shouldShowReservation && showGroupsTable">
                <fun-icon [name]="'info-circle'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
                <h2 *ngIf="showOverfundedWarning"
                    class="font-sans text-h600 md:text-h700 bg-gradient-2-text linear-gradient-2">{{
                    'INVEST.PROJECT_100' | translate }}</h2>
                <h2 *ngIf="!showOverfundedWarning"
                    class="font-sans text-h600 md:text-h700 bg-gradient-2-text linear-gradient-2">{{
                    'INVEST.PRIORITY_STATE' | translate }}</h2>
                <p class="font-sans text-gray-40 text-l">{{ 'INVEST.VIEW_PRIORITY_TABLE' | translate }}</p>

                <!-- Tabla de inversión por grupos -->
                <div class="w-full rounded-xl border border-eggplant-100/[0.15] overflow-hidden">
                    <div *ngFor="let group of groupsInvestmentData"
                        class="flex items-center justify-between px-16 py-12 border-b border-eggplant-100/[0.1] last:border-b-0"
                        [ngClass]="{'bg-[#e0e3ff]/50': group.isUserGroup}">
                        <div class="flex items-center gap-8">
                            <span class="font-sans text-m text-eggplant-100">G{{ group.priority }} · {{ group.name
                                }}</span>
                            <span *ngIf="group.isUserGroup"
                                class="text-s font-sans px-6 py-1 rounded-full bg-verified/20 text-verified">{{
                                'INVEST.YOUR_GROUP' | translate }}</span>
                        </div>
                        <span class="font-sansBold text-m text-eggplant-100">{{ group.contributedAmount |
                            number:'1.0-0':'es' }} €</span>
                    </div>
                    <!-- Usuarios globales -->
                    <div class="flex items-center justify-between px-16 py-12 bg-gray-10/30">
                        <span class="font-sans text-m text-eggplant-80">{{ 'INVEST.INVESTMENT_COMMIT' | translate
                            }}</span>
                        <span class="font-sansBold text-m text-eggplant-80">{{ globalUsersInvestment |
                            number:'1.0-0':'es' }} €</span>
                    </div>
                </div>

                <!-- Mensaje de máximo a invertir (solo al 100%) -->
                <div *ngIf="showOverfundedWarning"
                    class="flex items-center gap-8 px-16 py-12 rounded-xl bg-eggplant-100/[0.08] w-full">
                    <fun-icon [name]="'info-circle'"
                        [style]="'w-20 h-20 stroke-[2px] stroke-eggplant-100 flex-shrink-0'"></fun-icon>
                    <p class="font-sans text-m text-eggplant-100 text-left">{{ 'INVEST.MAX_G' | translate }}</p>
                </div>

                <!-- Advertencia de prioridad no garantizada -->
                <div *ngIf="showPriorityWarning"
                    class="flex items-start gap-8 px-16 py-12 rounded-xl bg-orange-100/15 border border-orange-100/30 w-full">
                    <fun-icon [name]="'alert-triangle'"
                        [style]="'w-20 h-20 stroke-[2px] stroke-orange-100 flex-shrink-0 mt-1'"></fun-icon>
                    <p class="font-sans text-s text-orange-100 text-left">{{ 'INVEST.MAX_G' | translate }}</p>
                </div>

                <fun-new-button size="l" [buttonType]="'colorFull'" title="Continuar con mi inversión"
                    (eventClick)="continueFromOverfundedWarning()"
                    [classExtra]="'!w-full max-w-[300px]'"></fun-new-button>
            </ng-container>

            <!-- Vista simple: usuario con grupo CON investObjective -->
            <ng-container *ngIf="!shouldShowReservation && !showGroupsTable && showOverfundedWarning">
                <fun-icon [name]="'alert-triangle'" [style]="'w-64 h-64 stroke-[2px] stroke-orange-100'"></fun-icon>
                <h2 class="font-sans text-h600 md:text-h700 bg-gradient-2-text linear-gradient-2">{{ 'INVEST.OBJ_100' |
                    translate }}</h2>
                <p class="font-sans text-gray-40 text-l">{{ 'INVEST.CONTINUE_WITH_YOUR_INVESTMENT' | translate }}
                    <span class="font-sansBold">{{ userPriorityGroup?.investObjective | number:'1.0-0':'es' }} €</span>
                    y queda disponible <span class="font-sansBold">{{ userGroupMaxInvestment | number:'1.0-0':'es' }}
                        €</span>.
                </p>
                <fun-new-button size="l" [buttonType]="'colorFull'" title="Continuar con mi inversión"
                    (eventClick)="continueFromOverfundedWarning()"
                    [classExtra]="'!w-full max-w-[300px]'"></fun-new-button>
            </ng-container>

        </div>
    </div>
    <!-- <fun-invest-success-taxdown *ngIf="step === 4 && hubspotQuestion" [username]="profile.username" (closeModalEvent)="goHome()"></fun-invest-success-taxdown> -->
</div>